import React from "react";
import styles from "./contact.module.scss";
import {
  contactIcon,
  githubIcon,
  linkedinIcon,
  twitterIcon,
} from "../../utils/svg";
import ContactImg from "@assets/images/contact.jpg";
import {
  InformationComponent,
  InformationMedia,
} from "../../components/information/information.component";

const GetInTouch: React.FC = () => {
  return (
    <div className={styles["column"]}>
      <blockquote>
        I&apos;m always excited to connect with new people, discuss interesting
        ideas, or explore potential collaborations.
      </blockquote>
      <p>
        Whether you have a question, want to chat about a project, or just want
        to <strong>say hello</strong>, I&apos;d love to hear from you!
      </p>
    </div>
  );
};

interface Channel {
  label: string;
  href: string;
  icon: string;
  viewBox: string;
}

const CHANNELS: readonly Channel[] = [
  {
    label: "Message me on X",
    href: "https://x.com/D4ni31_",
    icon: twitterIcon,
    viewBox: "0 0 512 512",
  },
  {
    label: "Connect on LinkedIn",
    href: "https://www.linkedin.com/in/daniel-de-witte/",
    icon: linkedinIcon,
    viewBox: "0 0 448 512",
  },
  {
    label: "View my GitHub",
    href: "https://github.com/Artimunor",
    icon: githubIcon,
    viewBox: "0 0 98 96",
  },
];

export const Contact: React.FC = () => {
  return (
    <div className={styles["contact"]}>
      <InformationComponent
        icon={contactIcon}
        sizeX={442}
        sizeY={442}
        kicker="TRANSMISSION"
        title="Get in touch">
        <GetInTouch />
      </InformationComponent>
      <div className={styles["contact-row"]}>
        <div className={styles["viewport"]}>
          <InformationMedia
            image={ContactImg}
            alt="A chrome beacon spire pulsing golden signal rings into the night sky"
            position="fill"
          />
        </div>
        <div className={styles["panel"]}>
          <h4>Details</h4>
          <ul className={styles["channels"]}>
            {CHANNELS.map((channel) => (
              <li key={channel.label}>
                <a
                  className={styles["channel"]}
                  href={channel.href}
                  target="_blank"
                  rel="noreferrer">
                  <svg viewBox={channel.viewBox} aria-hidden="true">
                    <path d={channel.icon} />
                  </svg>
                  <span>{channel.label}</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
